// @ vendor
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../constants/actionTypes');
const {
    OKCONSENTS_CONSENTS,
    OKCONSENTS_EMPTY_VALUE,
    OKCONSENTS_NEGATIVE_VALUE,
    OKCONSENTS_POSITIVE_VALUE,
    OKCONSENTS_LEGITIMATE,
    OKCONSENTS_CONSENTS_SWITCH,
    OKCONSENTS_CONSENTS_CHECKBOX
} = require('../constants/constants');

const initialState = Immutable.fromJS({
    consents: [],
    consentsEditInProgress: false,
    consentsInitialStatus: [],
    consentsIsEqualsToInitial: true,
    error: '',
    fetchSuccess: false,
    isFetching: false,
    neutral: {
        poEditor: ''
    },
    otp: false,
    placementId: '',
    placementViewInfo: {
        poEditorBody: '',
        poEditorTitle: ''
    },
    postError: '',
    postIsFetching: false,
    postSuccess: false,
    robinson: false,
    selectAll: {
        enabled: false,
        poEditor: ''
    },
});

function okConsentsReducer(state = initialState, action) {
    const immConsentsInitialStatus = state.get('consentsInitialStatus');
    let immUpdatedConsents;

    switch (action.type) {
        case actionTypes.OKCONSENTS_RESET:
            return state.merge(initialState);

        case actionTypes.OKCONSENTS_GET_CONSENTS_REQUEST:
            return state.merge(initialState, {
                fetchSuccess: false,
                isFetching: true
            });

        case actionTypes.OKCONSENTS_GET_CONSENTS_FAILURE:
            return state.merge(initialState, {
                error: action.payload.error,
                isFetching: false
            });

        case actionTypes.OKCONSENTS_GET_CONSENTS_SUCCESS:
            action.payload.config.consents.forEach(consent => {
                consent.channels = consent.channels || [];
            });

            return state.merge(action.payload.config, {
                consentsInitialStatus: action.payload.config.consents,
                error: '',
                fetchSuccess: true,
                isFetching: false,
                placementId: action.payload.placementId,
            });

        case actionTypes.OKCONSENTS_UPDATE_CONSENT_STATUS:
            immUpdatedConsents = state.get('consents').update(
                state.get('consents').findIndex(immConsent => immConsent.getIn(['consentCell', 'id']) === action.payload.questionId),
                (immConsent) => {
                    let immUpdatedConsent;
                    immUpdatedConsent = immConsent.merge({
                        channels: immConsent.get('channels').map(immChannel => immChannel.set('accepted', action.payload.status === OKCONSENTS_POSITIVE_VALUE)),
                        status: action.payload.status,
                    });
                    return immUpdatedConsent;
                }
            );

            return state.merge({
                consents: immUpdatedConsents,
                consentsEditInProgress: true,
                consentsIsEqualsToInitial: immUpdatedConsents.equals(immConsentsInitialStatus)
            });

        case actionTypes.OKCONSENTS_UPDATE_ALL_CONSENTS_STATUS:
            if (action.payload.status === OKCONSENTS_POSITIVE_VALUE){
                immUpdatedConsents = state.get('consents').map((immConsent, i) => {
                    let immUpdatedConsent;
                    const consentType = immConsent.getIn(['consentCell', 'displayType']);
                    if (consentType === OKCONSENTS_CONSENTS_SWITCH || consentType === OKCONSENTS_CONSENTS_CHECKBOX) {
                        immUpdatedConsent = immConsent.merge({
                            channels: immConsent.get('channels').map(immChannel => immChannel.set('accepted', action.payload.status === OKCONSENTS_POSITIVE_VALUE)),
                            status: action.payload.status,
                        });
                    } else {
                        immUpdatedConsent = immConsent;
                    }
                    return immUpdatedConsent;
                });
            } else {
                immUpdatedConsents = state.get('consents');
            }
            return state.merge({
                consents: immUpdatedConsents,
                consentsEditInProgress: true,
                consentsIsEqualsToInitial: immUpdatedConsents.equals(immConsentsInitialStatus)
            });

        case actionTypes.OKCONSENTS_UPDATE_CONSENTS_REQUEST:
            return state.merge({
                postIsFetching: true,
            });

        case actionTypes.OKCONSENTS_UPDATE_CONSENTS_FAILURE:
            return state.merge({
                postError: action.payload.error,
                postIsFetching: false,
            });

        case actionTypes.OKCONSENTS_UPDATE_CONSENTS_SUCCESS:
            return state.merge({
                postIsFetching: false,
                postSuccess: true,
            });

        case actionTypes.OKCONSENTS_UPDATE_CHECKBOX_CHANNEL:
            const consentIndex = state.get('consents').findIndex(immConsent => immConsent.getIn(['consentCell', 'id']) === action.payload.questionId);

            immUpdatedConsents = state.get('consents').update(consentIndex, immConsent =>
                immConsent.setIn(['channels', action.payload.channelIndex, 'accepted'], !immConsent.getIn(['channels', action.payload.channelIndex, 'accepted']))
            ).update(consentIndex,(immConsent) => {
                let immUpdatedConsent;

                if(immConsent.get('channels').every(immChannel => !!immChannel.get('accepted'))) {
                    immUpdatedConsent = immConsent.merge({
                        status: OKCONSENTS_POSITIVE_VALUE
                    });
                } else {
                    immUpdatedConsent = immConsent.merge({
                        status: OKCONSENTS_NEGATIVE_VALUE,
                    });
                }
                return immUpdatedConsent;
            });

            return state.merge({
                consents: immUpdatedConsents,
                consentsEditInProgress: true,
                consentsIsEqualsToInitial: immUpdatedConsents.equals(immConsentsInitialStatus)
            });

        default:
            return state;
    }

}

module.exports = okConsentsReducer;
